import React from 'react';
import { Box } from '@amzn/awsui-components-react';
import { withCookies } from 'react-cookie';
import { Redirect } from 'react-router';
import { Alert } from '@amzn/awsui-components-react';
import EndpointIdForm from '../EndpointIdForm';
import { IS_SAML_LOGOUT_COOKIE } from '../../constants';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.onSamlLogoutAlertDismiss = this.onSamlLogoutAlertDismiss.bind(this);
    this.state = {
      samlLogoutAlertDismissed: false,
    };
  }

  onSamlLogoutAlertDismiss() {
    this.setState({ samlLogoutAlertDismissed: true });
  }

  render() {
    if (this.props.location.pathname !== '/') {
      return <Redirect to="/" />;
    }

    const samlLogoutAlertVisible =
      this.props.cookies.get(IS_SAML_LOGOUT_COOKIE) === 'true';
    return (
      <>
        <div className="container-no-border awsui-util-container max-width-container">
          <Alert
            visible={
              samlLogoutAlertVisible && !this.state.samlLogoutAlertDismissed
            }
            onDismiss={this.onSamlLogoutAlertDismiss}
          >
            You have logged out of the endpoint session but be aware that your
            IDP SAML session may still be active until the session expiry time
            configured on your IDP by your IT administrator.
          </Alert>
          <div style={{ color: 'white' }}>
            <Box
              fontSize="heading-m"
              style={{ color: '#FFFFFF' }}
              color="inherit"
              padding="l"
            >
              Access your AWS Virtual Private Cloud via AWS Client VPN.
              {/* POLARIS_V3.0_MIGRATION_WARNING: `s` size spacing in 2.1 was automatically converted to `s`. You might need to use `xs` instead. Please read Polaris CSS utilties migration guide. */}
              <Box
                variant="p"
                margin={{ top: 'xs' }}
                style={{ color: '#FFFFFF' }}
                color="inherit"
              >
                You can use the self-service portal to get the tools that you’ll
                need to connect to AWS through a Client VPN endpoint. You can
                download the client configuration file (.ovpn file) for your VPN
                client application, and you can download the free AWS-provided
                VPN client. To get started, enter the ID of your Client VPN
                endpoint.
              </Box>
            </Box>
          </div>
        </div>

        <Box>
          <div
            style={{
              width: '1000px',
              height: '60px',
              backgroundColor: 'white',
              padding: '20px',
              margin: '30px auto 0',
            }}
          >
            <EndpointIdForm />
          </div>
        </Box>
      </>
    );
  }
}

export default withCookies(Home);
